export const ActionTypes = {
  SET_ZENDESK_TICKETS: 'SET_ZENDESK_TICKETS'
};
